import * as Types from './types';

export const setMenuVisible = (payload: boolean) => ({
  type: Types.HEADER_SET_MENU_VISIBLE,
  payload,
});
